export default __webpack_public_path__ + "static/media/SeñaleroIzquierdo.c6a91778.jpg";